<!-- <div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
</div> -->
<div class="page main-signin-wrapper" style="min-height: 55vh;">
    <div class="container">
        <div class="row">
            <div class="sign__header mb-4">
                <div class="sign__in text-center">
                    <h4 style="color: #1255f4;">Super Admin Update</h4>
                </div>
            </div>
            <div class="sign__form">
                <form [formGroup]="registrationForm" novalidate>
                    <div class="row">
                        <div class="col-sm-8">
                            <h6 class="mt-3">Mobile No.
                                <span>*</span>
                            </h6>
                            <div class="input-group  sign__input">
                                <input type="text" required class="form-control marg mrb b"
                                    [readOnly]="isMobileDisabled" maxlength="10"
                                    formControlName="StuMobNumber" placeholder="Mobile No."
                                    (input)="mobilevalid($event.target.value)"
                                    aria-label="Student's Mobile No." aria-describedby="basic-addon2">
                                <div *ngIf="resendMobotp" [class.disabled-div]="isDivDisabled2" style="margin-left: 2%;"
                                    class="input-group-append" (click)="resendMobWithTimeout()">
                                    <span class="input-group-text a e-btn w-100 colfff btnHight"
                                        id="basic-addon2">Resend OTP
                                    </span>
                                </div>
                                <div *ngIf="send1stMobotp" style="margin-left: 2%;"
                                    [class.disabled-div]="isDivDisabled2 || !isMobValid"
                                    class="input-group-append" (click)="verifySuperAdmin()">
                                    <span class="input-group-text a e-btn w-100 colfff btnHight"
                                        id="basic-addon2">Send OTP
                                    </span>
                                </div>
                                <div *ngIf="isDivDisabled2" class="timer red11" style="margin-left: 2%;">{{ remainingTime2 }}s</div>
                            </div>
                            <mat-error class="margin_tp"
                                *ngIf="registrationForm.controls['StuMobNumber'].touched && registrationForm.controls['StuMobNumber'].errors?.pattern">
                                Invalid
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="registrationForm.controls['StuMobNumber'].touched && registrationForm.controls['StuMobNumber'].errors?.required">
                                Mandatory
                            </mat-error>
                        </div>
                        <div class="col-sm-8">
                            <h6 class="mt-3">Enter OTP Received On Mobile No.
                                <span>*</span>
                            </h6>
                            <div class="input-group mb-3 sign__input">
                                <input required type="text" class="form-control mrb b"
                                    formControlName="mobileOTP" placeholder="OTP Received On Mobile No."
                                    aria-label="Enter Otp Received On Mobile No."
                                    aria-describedby="basic-addon2">
                                <div *ngIf="otpverify2" class="input-group-append" (click)="verifyMobOtp()" style="margin-left: 2%;">
                                    <span class="input-group-text btnHight bgcolorrrr a e-btn w-100 colfff"
                                        id="basic-addon2">Verify OTP</span>
                                </div>

                                    </div>
                                    <div *ngIf="msgshw3" class="greennn text-center">
                                        <p><b> {{messageee2}}</b></p>
                                    </div>
                                    <div *ngIf="msgshw4" class="red text-center">
                                        <p><b> {{messageee2}}</b></p>
                                    </div>
                                    <mat-error class="margin_tp"
                                        *ngIf="registrationForm.controls['mobileOTP'].touched && registrationForm.controls['mobileOTP'].errors?.required">
                                        Mandatory
                                    </mat-error>
                                </div>
                            </div>
                                <!-- <button class="e-btn w-100 colfff col-sm-3 offset-sm-7 mt-1"
                                    type="submit" (click)="Update()">Sign-In</button> -->
                                <!-- <button *ngIf="btnShow2" disabled
                                    class="disabled-div e-btn w-100 col-red col-sm-6 offset-sm-3 mt-1" type="submit"
                                    (click)="register()">Register</button> -->
                        </form>
            </div>
        </div>
    </div>
</div>